import { isNil, isNotNil } from "@etudescarre/utils";
import { GearSixIcon } from "@phosphor-icons/react";
import { formatDay } from "@/lib/utils/date";
import { useYardContext } from "@/providers/yard-context";

const YARD_TYPE_LABELS: Record<string, string> = {
  lots_separes: "Lots séparés",
  entreprise_generale: "Entreprise générale",
  conception_realisation: "Conception-réalisation",
};

export function YardSettings() {
  const { yard } = useYardContext();

  const formatDate = (date: string | null) => {
    if (isNil(date)) return "-";
    return formatDay(date);
  };

  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      <div className="mb-8 flex items-center gap-3">
        <GearSixIcon className="size-8 text-zinc-400" />
        <div>
          <h2 className="text-xl font-semibold text-zinc-900 dark:text-zinc-100">
            Réglages du chantier
          </h2>
          <p className="text-sm text-zinc-500">{yard.name}</p>
        </div>
      </div>

      <div className="rounded-lg border border-zinc-200 bg-white p-6 dark:border-zinc-700 dark:bg-zinc-900">
        <h3 className="mb-4 text-sm font-medium text-zinc-700 dark:text-zinc-300">
          Informations générales
        </h3>
        <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <dt className="text-xs font-medium text-zinc-500">
              Nom du chantier
            </dt>
            <dd className="mt-1 text-sm text-zinc-900 dark:text-zinc-100">
              {yard.name}
            </dd>
          </div>
          <div>
            <dt className="text-xs font-medium text-zinc-500">Type</dt>
            <dd className="mt-1 text-sm text-zinc-900 dark:text-zinc-100">
              {YARD_TYPE_LABELS[yard.type] ?? yard.type}
            </dd>
          </div>
          <div>
            <dt className="text-xs font-medium text-zinc-500">
              Date de mise en service
            </dt>
            <dd className="mt-1 text-sm text-zinc-900 dark:text-zinc-100">
              {formatDate(yard.comissioningDate)}
            </dd>
          </div>
          <div>
            <dt className="text-xs font-medium text-zinc-500">
              Date d'expiration
            </dt>
            <dd className="mt-1 text-sm text-zinc-900 dark:text-zinc-100">
              {formatDate(yard.expirationDate)}
            </dd>
          </div>
          <div>
            <dt className="text-xs font-medium text-zinc-500">
              Jours avant archivage
            </dt>
            <dd className="mt-1 text-sm text-zinc-900 dark:text-zinc-100">
              {isNotNil(yard.beforeArchivingDays)
                ? `${yard.beforeArchivingDays} jours`
                : "-"}
            </dd>
          </div>
          {isNotNil(yard.moaCompanyName) && (
            <div>
              <dt className="text-xs font-medium text-zinc-500">
                Maître d'ouvrage
              </dt>
              <dd className="mt-1 text-sm text-zinc-900 dark:text-zinc-100">
                {yard.moaCompanyName}
              </dd>
            </div>
          )}
        </dl>
      </div>
    </div>
  );
}
